import { z } from 'zod';

export type SearchParams = z.infer<typeof searchSchema>;

const searchSchema = z.object({
  shid: z.string().optional(),
  retailer: z.string().optional(),
  orderNumber: z.string().optional(),
  order: z.string().optional(),
  email: z.email({ message: 'Invalid email address' }).optional(),
  request: z.string().optional(),
  token: z.string().optional(),
  locale: z.string().optional(),
  zipCode: z.string().optional(),
  itemId: z.string().optional(),
  resolutionId: z.string().optional(),
  claimId: z.string().optional(),
  isGift: z.string().optional(),
  complete: z.string().optional(),
  // Agent mode query param - simulates agent permissions when set to 'true'
  // In production, agent status will be determined by Salesforce authentication
  // Uses strict transform to avoid z.coerce.boolean() gotcha where "false" -> true
  agent: z
    .union([z.boolean(), z.string()])
    .transform((val) => val === true || val === 'true')
    .optional(),
  // MX mode query param - opts the page into MX-driven features (branded header
  // first) for verification before the full cutover. Same strict transform as agent.
  mx: z
    .union([z.boolean(), z.string()])
    .transform((val) => val === true || val === 'true')
    .optional(),
});

export const validateSearch = (search: Record<string, unknown>) => {
  const result = searchSchema.safeParse(search);
  return result.data;
};

const urlParams = () => new URLSearchParams(window.location.search);
export const getParams = () => validateSearch(Object.fromEntries(urlParams()));
export const getCountryCode = () => getParams()?.locale?.split('_')[1] ?? 'US';
